// Environment configuration based on the old Angular app
export const environment = {
  production: import.meta.env.PROD,
  serverUrls: {
    localhost: 'http://localhost:3000/api/',
    'xkey.fi': 'https://xkey-backend-prod-afvpvcd5qa-lz.a.run.app/api/',
    'dev.xkey.fi': 'https://xkey-backend-dev-866790499670.europe-north1.run.app/api/',
    'xkey-frontend-nova-866790499670.europe-north1.run.app':
      'https://xkey-backend-nova-866790499670.europe-north1.run.app/api/',
    // Add other domains as needed
  },
  domain: import.meta.env.PROD ? 'https://xkey.fi' : 'http://localhost:5173',
  useAnalytics: import.meta.env.PROD,
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || '',
  logo: '/xkey-clean-small.png',
  timezone: 'Europe/Helsinki', // Finnish timezone
  locale: 'fi-FI', // Finnish locale

  // File version history retention, mirrored from the GCS bucket lifecycle
  // policy applied in `ops/gcs/lifecycle-*.json` on the backend. When those
  // JSON files change, update these too so the UI's expiry countdown stays
  // truthful. Currently prod and dev share the same limits.
  fileVersioning: {
    retentionDays: 90,
    maxNoncurrentVersions: 10,
  },

  getServerUrl(): string {
    // In development, use the Vite proxy (no need for full URL)
    if (!this.production) {
      return '/api/';
    }

    // In production, use the full URL based on hostname
    const hostname = window.location.hostname;
    const url = this.serverUrls[hostname as keyof typeof this.serverUrls];
    if (!url) {
      console.warn(`[environment] Unknown hostname "${hostname}", falling back to localhost API`);
    }
    return url || this.serverUrls.localhost;
  },
};

export default environment;
